import {RichTextInstructions} from '../../../types/richTextInstructions'

export interface TaskSettings {
  [siteName: string]: {
    [taskGroupName: string]: TaskSettingItem[]
  }
}

interface TaskSettingItem {
  id: string
  name: string
  icon: string
  siteExamples: string[]
  siteAmount: number
  instructions?: RichTextInstructions | null
  description?: string | null
  target: string
  type: string
}

interface SettingsState {
  data: TaskSettings
  pending: boolean
  error: Error | null
  exportPending?: boolean
}

export const state: SettingsState = {
  data: {},
  pending: false,
  error: null,
  exportPending: false
}
